import Time from "../../../assets/icons/Time";
import Burger from "../assets/icons/Burger";
import Calendar from "../assets/icons/Calendar";
import Screen from "../../../assets/icons/Screen";
import Pencil from "../assets/icons/Pencil";
import Check from "../assets/icons/Check";
import Search from "../assets/icons/Search";
import Dispatcher from "../assets/icons/Dispatcher";
import Route from "../assets/icons/Route";
import SmartDual from "../assets/icons/SmartDual";
import Camera from "../assets/icons/Camera";
import Document from "../assets/icons/Document";
import FullTime from "../assets/icons/FullTime";
import Electr from "../assets/icons/Electr";
import Carbon from "../assets/icons/Carbon";

export const LogItems = [
    {
        "id": 1,
        "icon": <Time />,
        "title": "Today’s Log",
        "text": "Tap on TODAY’s log to view & manage your current log"
    },
    {
        "id": 2,
        "icon": <Burger />,
        "title": "Logs History",
        "text": `View past logs & violations
        if any. Tap on a log you
        would like to view or edit`
    },
    {
        "id": 3,
        "icon": <Calendar />,
        "title": "Graph Grid",
        "text": `Similar to paper logs, view
        your hours or service on the
        graph grid.`
    },
    {
        "id": 4,
        "icon": <Screen />,
        "title": "Statuses/Events",
        "text": `Tap on a specific status in the
        events section to view
        location and notes.`
    },
    {
        "id": 5,
        "icon": <Pencil />,
        "title": "Edit/Insert Status",
        "text": `Press on “Pencil” to edit or “+”
        to insert a past duty status.`
    },
    {
        "id": 6,
        "icon": <Check />,
        "title": "Certify Log",
        "text": "Tap “Certify” and sign your log when your shift ends."
    },
]

export const DriverItems = [
    {
        "id": 1,
        "icon": <Check />,
        "title": "Hours of Service",
        "text": `View current status and real-time hours. Available and
        reset hours are calculated automatically.`
    },
    {
        "id": 2,
        "icon": <Check />,
        "title": "Driver Logs",
        "text": `View current log graph grid and last 14 logs. Click on a log
        to see log details. Click “More” to view historical logs.`
    },
    {
        "id": 3,
        "icon": <Check />,
        "title": "Violations & Errors",
        "text": `Monitor violations and errors in real time. View past
        violations and mitigate compliance risks.`
    },
    {
        "id": 4,
        "icon": <Check />,
        "title": "Details",
        "text": `View driver contact information, current or last known
        vehicle and location.`
    },
]

export const LogItems1 = [
    {
        "id": 1,
        "icon": <Burger />,
        "title": "View logs",
        "text": `View all current and past logs
        up to six months.`
    },
    {
        "id": 2,
        "icon": <Search />,
        "title": "Filter",
        "text": `Filter by date or driver`
    },
    {
        "id": 3,
        "icon": <Check />,
        "title": "Violations",
        "text": `Monitor violations in real time`
    }
]

export const LogItems2 = [
    {
        "id": 1,
        "icon": <Check />,
        "title": "Log Form",
        "text": `Form and manner errors are displayed automatically.`
    },
    {
        "id": 2,
        "icon": <Check />,
        "title": "Vehicles & Trailers",
        "text": `View vehicle & trailer information. Check shipping
        documents numbers.`
    },
    {
        "id": 3,
        "icon": <Check />,
        "title": "Log events",
        "text": `Check log events. Click on event to suggest an edit. Click
        “+” to suggest to add an event.`
    },
    {
        "id": 4,
        "icon": <Check />,
        "title": "Log Date",
        "text": `Click on a calendar in the top right corner to change a
        date or click “<->” to switch between logs,`
    },
]

export const IconItems=[
    {
        "id":0,
        "icon":<Dispatcher/>,
        "title":"Automatic HOS",
        "text":`Automatic hours of service calculation and violation alerts.
        Automatic recording of driving time, miles and locations.`,
    },
    {
        "id":1,
        "icon":<Route/>,
        "title":"Compliance Monitoring",
        "text":`Monitor your drivers’ hours of service logs and DVIRs.
        Receive alerts to prevent violations.`,
    },
    {
        "id":2,
        "icon":<SmartDual/>,
        "title":"DOT Inspection Mode",
        "text":`Simply show logs on your phone or tablet.
        No printer needed.`,
    },
    {
        "id":3,
        "icon":<Camera/>,
        "title":"Fleet Tracking",
        "text":`Track your vehicles in real time and view their
        location history`,
    },
    {
        "id":4,
        "icon":<Carbon/>,
        "title":"Multiple HOS Rules",
        "text":`Compliant with multiple HOS rules including
        Property/Passenger 60-hour/7-day & 70-hour/8-day.`,
    },
    {
        "id":5,
        "icon":<Document/>,
        "title":"IFTA reporting",
        "text":`Automatic IFTA state mileage reporting saves you
        time and money`,
    },
    {
        "id":6,
        "icon":<Electr/>,
        "title":"Electronic DVIR",
        "text":`Vehicle inspection reports are created and
        submitted in seconds.`,
    },
    {
        "id":7,
        "icon":<FullTime/>,
        "title":"Access Permissions",
        "text":`Manage permissions for fleet managers, compliance
        officers, drivers, accountants, brokers and customers`,
    },
]